import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/website/website/src/app/services/content.tsx");
